module.exports = __webpack_public_path__ + "static/remote-work-9b97750762414ca26997cfe8346b9f61.png";